import React, { useState } from 'react'
import { Box, Button, Typography } from '@mui/material'
import PlainModal from '../../../../../components/modal/PlainModal'
import InputComponent from '../../../../../components/ui/InputComponent'
import RewardTip from '../../../../../components/leaderboard/RewardTip'

interface NewsletterProps {
  open: boolean
  handleClose: () => void
  actionButton: (email: string) => void
}

const Newsletter: React.FC<NewsletterProps> = ({
  open,
  handleClose,
  actionButton,
}) => {
  const [email, setEmail] = useState('')

  const handleSubscribe = (): void => {
    if (!email) return
    actionButton(email)
    setEmail('')
    handleClose()
  }

  return (
    <PlainModal
      open={open}
      handleClose={handleClose}
      modelWidth="500px"
      title=" Join Our Newsletter"
    >
      <Box>
        <RewardTip title="Get up to 20 Points on joining as newsletter" />
        <Box mt={4}>
          <Typography variant="subtitle2" mb={0.5}>
            Email
          </Typography>
          <Box display="flex" alignItems="center" gap={1}>
            <InputComponent
              value={email}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setEmail(e.target.value)
              }
              placeholder="Enter your email"
              sx={{ flex: 1 }}
            />

            <Button variant="outlined" onClick={handleSubscribe}>
              Subscribe
            </Button>
          </Box>
        </Box>
      </Box>
    </PlainModal>
  )
}

export default Newsletter
